<div class="auth-backdrop">
  <div class="auth-gradient-mesh"></div>
  <img class="auth-watermark" src="favicon.svg" alt="" aria-hidden="true" />
  <div class="auth-orb auth-orb--1"></div>
  <div class="auth-orb auth-orb--2"></div>
  <div class="auth-orb auth-orb--3"></div>
  <div class="auth-noise"></div>
</div>
<div class="matero-auth-container">
  <router-outlet></router-outlet>
</div>
